import { useEffect, useState } from "react";
import Close from "../../../assets/icons/close.svg";
import Fav from "../../../assets/icons/fav-outline.svg";
import { AddonsPropType, ItemCampaignsPropType } from "../../home/types";
import VariationCardCheckBox from "../../restaurant/components/VariationCardCheckBox";
import VariationCardRadioBox from "../../restaurant/components/VariationCardRadioBox";
import Button from "../../../components/ui/button";
import AddonCard from "../../restaurant/components/AddonCard";
import LongText from "../../restaurant/components/LongText";
import Variation from "../../restaurant/components/Variation";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../..";
import {
  addAddonsItemCart,
  addToCart,
  clearCart,
  decrementAddonQuantity,
  decrementSubCartQuantity,
  incrementSubCartQuantity,
  setCart,
  addRequiredVariationsItemCart,
  addVariationsItemCart,
} from "../../cart/reducer";
import ResetCart from "../../../components/modal/ResetCart";
import notify from "../../../utils/notify";

type PropTYpe = {
  onClose: () => void;
  item: ItemCampaignsPropType;
  restaurant: ItemCampaignsPropType;
};

const SpecialOfferPopup = ({ onClose, item, restaurant }: PropTYpe) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const subCart = useSelector((state: IRootState) => state.cart.value.subCart);
  const cart = useSelector((state: IRootState) => state.cart.value.cart);
  const user = useSelector((state: IRootState) => state.user.value);
  const { loggedIn } = user;
  const isInCart = cart.find((cart) => cart.menu_id === item.id);

  const [addon, setAddon] = useState<AddonsPropType[]>([]);

  const newAddon = item.add_ons.map((addon) => ({ ...addon, quantity: 1 }));
  const [isVendor, setIsVendor] = useState(false);
  const active_vendor = localStorage.getItem("active-vendor") || "";
  const [error, setError] = useState("");

  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    setAddon(newAddon);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const onToggleFavorite = () => {
  //   if (loggedIn) {
  //     if (item.wishlist !== null) {
  //       Favorite.deleteFavoriteItem(item.id)
  //         .then((res) => {
  //           if (res.success) {
  //           } else {
  //             notify("error", res.mesage);
  //           }
  //         })
  //         .catch(() => {
  //
  //         });
  //     } else {
  //       Favorite.addFavorite({
  //         type: "ITEM",
  //         wishlist: item.id,
  //       })
  //         .then((res) => {
  //           if (res.success) {
  //           } else {
  //             notify("error", res.mesage);
  //           }
  //         })
  //         .catch(() => {
  //
  //         });
  //     }

  //     dispatch(toggleFavorite(item.establishment!.id));
  //   } else {
  //     notify("error", "Please login to add to favourite");
  //   }
  // };

  const [isClosing, setIsClosing] = useState(false);
  const [qty, setQty] = useState(1);

  const v = item.variations.filter((v) => v.type === "single");

  const handleBackgroundClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  };

  const onAddAddons = (item: AddonsPropType) => {
    dispatch(
      addAddonsItemCart({
        addons_id: item.id,
        addons_name: item.addon_name,
        addons_quantity: 1,
        addons_total: item.quantity! * item.addon_price,
        addons_price: item.addon_price,
      })
    );
  };

  const onIncrease = (it: AddonsPropType) => {
    dispatch(
      addAddonsItemCart({
        addons_id: it.id,
        addons_name: it.addon_name,
        addons_quantity: 1,
        addons_total: it.quantity! * it.addon_price,
        addons_price: it.addon_price,
      })
    );
    setAddon((prevItem) => {
      return prevItem.map((item) => {
        if (item.id === it.id) {
          return { ...item, quantity: item.quantity! + 1 };
        }
        return item;
      });
    });
  };
  const onDecrease = (id: number) => {
    dispatch(decrementAddonQuantity(id));
    setAddon((prevItem) => {
      return prevItem.map((item) => {
        if (item.id === id) {
          if (item.quantity === 1) {
            return { ...item, quantity: (item.quantity! = 1) };
          }
          return { ...item, quantity: item.quantity! - 1 };
        }
        return item;
      });
    });
  };

  const onIncreaseFood = () => {
    dispatch(incrementSubCartQuantity(item.id));
    setQty(qty + 1);
  };

  const onDecreaseFood = () => {
    dispatch(decrementSubCartQuantity(item.id));
    if (qty === 1) {
      return;
    }
    setQty(qty - 1);
  };

  const addItemToCart = () => {
    localStorage.setItem("price", JSON.stringify(subCart!.menu_price));

    const finalVariations: {
      id: string;
      required: boolean;
      quantity: number;
      total: number;
      price: number;
      label: string;
    }[] = [];

    // Process selected radio options
    Object.entries(selectedOptions).forEach(([variationName, optionLabel]) => {
      const variationGroup = item.variations.find(
        (vg) => vg.name === variationName
      );
      const selectedOptionData = variationGroup?.values.find(
        (v) => v.label === optionLabel
      );
      if (variationGroup && selectedOptionData) {
        finalVariations.push({
          id: selectedOptionData.label,
          required: variationGroup.required,
          quantity: 1,
          total: selectedOptionData.optionPrice,
          price: selectedOptionData.optionPrice,
          label: selectedOptionData.label,
        });
      }
    });

    // Process selected checkboxes
    Object.entries(selectedCheckboxes).forEach(
      ([variationName, selectedLabels]) => {
        const variationGroup = item.variations.find(
          (vg) => vg.name === variationName
        );
        selectedLabels.forEach((label) => {
          const selectedOptionData = variationGroup?.values.find(
            (v) => v.label === label
          );
          if (variationGroup && selectedOptionData) {
            finalVariations.push({
              id: selectedOptionData.label,
              required: variationGroup.required,
              quantity: 1,
              total: selectedOptionData.optionPrice,
              price: selectedOptionData.optionPrice,
              label: selectedOptionData.label,
            });
          }
        });
      }
    );

    const validateVariations = () => {
      let isValid = true;
      setError(""); // Clear previous errors

      item.variations.forEach((group) => {
        if (group.required) {
          if (group.type === "single") {
            if (!selectedOptions[group.name]) {
              setError(
                (prevError) =>
                  prevError || "Please select the required variations"
              );
              isValid = false;
            }
          } else {
            const selection = selectedCheckboxes[group.name] || [];
            if (
              selection.length < Number(group.min) ||
              selection.length > Number(group.max)
            ) {
              setError(
                (prevError) =>
                  prevError ||
                  `Please select between ${group.min} and ${group.max} options for ${group.name}`
              );
              isValid = false;
            }
          }
        }
      });
      return isValid;
    };

    if (!validateVariations()) {
      setError("Please select the required variations");
      return;
    }

    // Proceed to add to cart logic
    if (v.length === 0) {
      if (subCart!.active_vendor === active_vendor || !active_vendor) {
        dispatch(
          addToCart({
            is_campaign: false,
            establishment_id: restaurant.id,
            menu_id: subCart!.menu_id,
            menu_quantity: subCart!.menu_quantity,
            menu_name: subCart!.menu_name,
            menu_total: subCart!.menu_total,
            menu_price: subCart!.menu_price,
            menu_image: subCart!.menu_image,
            menu_addons: subCart!.menu_addons,
            menu_variation: finalVariations, // Use the constructed variations array
          })
        );
        dispatch(
          setCart({
            country: restaurant?.establishment?.country,
            establishment: restaurant,
          })
        );
        localStorage.setItem("vendor", JSON.stringify(item));
        localStorage.setItem("active-vendor", subCart!.active_vendor!);
        onClose();
      } else {
        setIsVendor(true);
      }
      return;
    }

    // Handle variations with valid selected options
    // if (selectedOption !== "" && currentCount >= 1) {
    if (subCart!.active_vendor === active_vendor || !active_vendor) {
      dispatch(
        addToCart({
          is_campaign: false,
          establishment_id: restaurant.id,
          menu_id: subCart!.menu_id,
          menu_quantity: subCart!.menu_quantity,
          menu_name: subCart!.menu_name,
          menu_total: subCart!.menu_total,
          menu_price: subCart!.menu_price,
          menu_image: subCart!.menu_image,
          menu_addons: subCart!.menu_addons,
          menu_variation: finalVariations, // Use the constructed variations array
        })
      );
      dispatch(
        setCart({
          country: restaurant?.establishment?.country,
          establishment: restaurant,
        })
      );
      localStorage.setItem("vendor", JSON.stringify(item));
      localStorage.setItem("active-vendor", subCart!.active_vendor!);
      onClose();
    } else {
      setIsVendor(true);
    }
    // }
    // else {
    //    setError("Select required Variation");
    //    notify("error", "Please select a required variation");
    // }
  };

  const getTotalAmountForCartItem = () => {
    let subtotal =
      Number(subCart?.menu_price || 0) * Number(subCart?.menu_quantity || 1);

    // Add the price of addons
    if (subCart?.menu_addons) {
      subCart.menu_addons.forEach((addon) => {
        subtotal += addon.addons_price * addon.addons_quantity;
      });
    }

    // Add the price of variations
    Object.entries(selectedOptions).forEach(([key, value]) => {
      const variationGroup = item.variations.find(
        (group) => group.name === key
      );
      const selectedOption = variationGroup?.values.find(
        (option) => option.label === value
      );
      if (selectedOption) {
        subtotal += selectedOption.optionPrice;
      }
    });

    Object.entries(selectedCheckboxes).forEach(([key, values]) => {
      const variationGroup = item.variations.find(
        (group) => group.name === key
      );
      values.forEach((value) => {
        const selectedOption = variationGroup?.values.find(
          (option) => option.label === value
        );
        if (selectedOption) {
          subtotal += selectedOption.optionPrice;
        }
      });
    });

    return subtotal;
  };

  const [selectedOptions, setSelectedOptions] = useState<
    Record<string, string>
  >({});
  // State for checkbox counts (multi-choice)
  const [counter, setCounter] = useState<number>(0);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState<
    Record<string, string[]>
  >({});

  const handleAddRadioOption = (
    variationName: string,
    optionLabel: string,
    optionPrice: number
  ) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [variationName]: optionLabel,
    }));
  };

  const handleCheckboxToggle = (
    variationName: string,
    itemLabel: string,
    isChecked: boolean,
    optionPrice: number,
    variationGroup: any
  ) => {
    const isMaxSelected =
      selectedCheckboxes[variationName]?.length >= Number(variationGroup.max) &&
      isChecked;
    if (isMaxSelected) {
      notify(
        "warn",
        `You can select a maximum of ${variationGroup.max} options for ${variationName}`
      );
      return;
    }

    setSelectedCheckboxes((prev) => {
      const currentSelection = prev[variationName] || [];
      if (isChecked) {
        return {
          ...prev,
          [variationName]: [...currentSelection, itemLabel],
        };
      } else {
        return {
          ...prev,
          [variationName]: currentSelection.filter(
            (label) => label !== itemLabel
          ),
        };
      }
    });
  };

  const onContinue = () => {
    dispatch(clearCart());
    setIsVendor(false);
    localStorage.removeItem("active-vendor");
  };

  return (
    <>
      {isVendor && (
        <ResetCart
          setIsVendor={() => setIsVendor(false)}
          onContinue={onContinue}
        />
      )}
      <div
        className="fixed flex flex-col w-full h-full z-[2147483009] scrollbar-thin overflow-y-scroll bg-trans5  inset-0  transition-opacity"
        onClick={handleBackgroundClick}
      >
        <div className="relative flex flex-col bg-white mt-auto md:my-[5%] mx-auto w-full md:w-[50%] lg:w-[40%] xl:w-[35%] rounded-tr-lg rounded-tl-lg md:rounded-[24px]">
          <div
            className="h-[200px] bg-green-400 justify-between bg-cover rounded-t-lg  md:rounded-t-[24px] flex flex-col p-3 md:p-4"
            style={{ backgroundImage: `url(${item.image})` }}
          >
            <div className=" p-2 cursor-pointer bg-primary rounded-full self-end w-fit">
              <img src={Close} alt="" onClick={onClose} />
            </div>
            <div className="flex flex-col gap-3">
              {/* <div className="flex items-center gap-2 bg-primary p-1 px-2 w-fit">
              <div className="text-white text-xs font-normal">
                {item.rating_count.toFixed(2)}
              </div>
            </div> */}
              <div className="flex items-center justify-between">
                <div
                  className="text-white font-medium text-base md:text-lg cursor-pointer"
                  onClick={() => {
                    navigate(
                      `/${item.establishment?.establishment_type.toLocaleLowerCase()}/${
                        item.establishment?.slug
                      }`
                    );
                  }}
                >
                  {item.establishment?.name}
                </div>
                {/* <div className=" p-2 cursor-pointer bg-white rounded-full w-fit">
                  <FavouriteButton
                    onToggle={onToggleFavorite}
                    isFav={item.wishlist !== null}
                  />
                </div> */}
              </div>
            </div>
          </div>
          <div className="flex flex-col p-3 md:p-4 gap-3 border-b">
            <div className="text-black font-medium text-base md:text-lg">
              {item.title}
            </div>
            {item.description && (
              <LongText maxLength={70} text={item.description} />
            )}
            <div className="flex items-center justify-between">
              <div className="flex flex-col md:flex-row items-center gap-1">
                <div className="whitespace-nowrap text-base font-medium">
                  Starts from :
                </div>
                <div
                  className="flex gap-2 items-baseline w-full"
                  // onClick={() => onClick(data)}
                >
                  {item.discount !== 0 && (
                    <div className="text-[#727272] text-xs font-normal line-through">
                      {item.establishment?.country.country_currency_symbol ||
                        ""}{" "}
                      {item.discount_type === "percent"
                        ? `${
                            Number(item.price) +
                            (Number(item.discount) / 100) * Number(item.price)
                          }`
                        : `${Number(item.price) + Number(item.discount)}`}
                    </div>
                  )}
                  <div className="text-primary font-semibold text-sm">
                    {item.establishment?.country.country_currency_symbol || ""}{" "}
                    {item.price}
                  </div>
                </div>
                {item.discount !== 0 && (
                  <div className="whitespace-nowrap bg-primary text-white font-normal text-[10px] rounded-sm p-1">
                    {item.discount_type === "percent"
                      ? `${item.discount}%`
                      : `${
                          item.establishment?.country.country_currency_symbol ||
                          ""
                        } ${item.discount}`}{" "}
                    OFF
                  </div>
                )}
              </div>
              {/* Quantity */}
              <div className="flex gap-3 items-center">
                <div
                  className={`cursor-pointer w-7 h-7 rounded-full flex items-center justify-center text-white  ${
                    qty > 1 ? "bg-primary" : "bg-[#E0E0E0]"
                  }`}
                  onClick={onDecreaseFood}
                >
                  -
                </div>
                <div className="">{qty}</div>
                <div
                  className="cursor-pointer w-7 h-7 rounded-full flex items-center justify-center text-white bg-primary"
                  onClick={onIncreaseFood}
                >
                  +
                </div>
              </div>
            </div>
          </div>
          {/* Adon */}
          <div className="flex flex-col p-3 md:p-4 gap-3">
            {item.add_ons.length > 0 && (
              <div className="flex flex-col">
                <div className=" text-base font-medium">Add Ons:</div>
                <div className="">
                  {addon.map((addon) => (
                    <AddonCard
                      currencySymbol={
                        item.establishment?.country.country_currency_symbol ||
                        ""
                      }
                      onAdd={() => onAddAddons(addon)}
                      addon={addon}
                      key={addon.id}
                      onIncrease={() => onIncrease(addon)}
                      onDecrease={() => onDecrease(addon.id)}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* Variation */}
          <div className="mb-2">
            {/* {item.variations.length > 0 && (
            <Variation
              variation={item.variations}
              onIncrease={() => {}}
              currencySymbol={
                item.establishment?.country.country_currency_symbol || ""
              }
              selectedOption={selectedOption} 
              setSelectedOption={setSelectedOption}
            />
          )}  */}
            {item.variations.length > 0 && (
              <div>
                <h3>Variations</h3>
                <div className="flex flex-col px-4 gap-3">
                  {item.variations.map((variationGroup) => (
                    <div className="flex flex-col" key={variationGroup.name}>
                      <div className="flex items-baseline gap-1 text-base font-medium">
                        {variationGroup.name}:{" "}
                        <span className="text-xs">
                          {variationGroup.required && "(required)"}
                        </span>
                        <div className="text-xs">
                          max(
                          {variationGroup.type === "single"
                            ? "1"
                            : variationGroup.max}
                          )
                        </div>
                      </div>
                      {variationGroup.type === "single" ? (
                        <div>
                          {variationGroup.values.map((item) => (
                            <div className="md:pl-10" key={item.label}>
                              <div className="flex justify-between">
                                <div className="flex items-center gap-2">
                                  <label className="flex items-center gap-2">
                                    <input
                                      type="radio"
                                      name={variationGroup.name} // Unique group name
                                      value={item.label}
                                      max={1}
                                      checked={
                                        selectedOptions[variationGroup.name] === item.label
                                      }
                                      onChange={() =>
                                        handleAddRadioOption(
                                          variationGroup.name,
                                          item.label,
                                          item.optionPrice
                                        )
                                      }
                                      required={variationGroup.required}
                                      className="accent-primary"
                                    />
                                    <span className="text-[#727272] text-sm font-normal">
                                      {item.label}
                                    </span>
                                  </label>
                                </div>
                                {item.optionPrice !== 0 && (
                                  <div className="text-[#727272] text-sm font-normal">
                                    +
                                    {
                                      restaurant?.establishment?.country
                                        ?.country_currency_symbol
                                    }{" "}
                                    {item.optionPrice}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div>
                          {variationGroup.values.map((item) => (
                           <VariationCardCheckBox
                           key={item.label}
                           max={variationGroup.max}
                           min={Number(variationGroup.min) > 1 ? (setError("Please add variation"), Number(variationGroup.min)) : 0}
                           required={!!variationGroup.required}
                           currencySymbol={restaurant?.establishment?.country.country_currency_symbol || ""}
                           item={item}
                           onAddVariation={(label, isChecked) => {
                             handleCheckboxToggle(variationGroup.name, label, isChecked, item.optionPrice, variationGroup);
                           }}
                         />
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="px-4 text-primary text-xs">{error}</div>
          <div className="border-t flex items-center justify-between p-3">
            <div className="flex gap-2 items-center">
              <div className="text-[#727272] font-normal">Total</div>
              <div className="text-primary font-medium">
                {item.establishment?.country.country_currency_symbol}{" "}
                {getTotalAmountForCartItem()}
              </div>
            </div>
            <div className="md:w-[70%]">
              <Button
                label={isInCart ? "Update Cart" : "Add to Cart"}
                loading={false}
                onClick={addItemToCart}
                color="orange"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecialOfferPopup;
